
export default {
    name: 'PrintResponseButton',
    props: {
        fileName: {
            type: String,
        },
    },
    methods: {
        printResponse() {
            const printEl = document.querySelector('#formResponseViewer') as HTMLElement

            if (!printEl) {
                return
            }

            const documentTitle = document.title
            const div = document.createElement('div')
            div.classList.add('print-only')
            div.innerHTML = printEl.innerHTML
            document.body.appendChild(div)

            window.addEventListener(
                'afterprint',
                () => {
                    document.body.removeChild(div)
                    document.title = documentTitle
                },
                { once: true }
            )

            if (this.fileName) {
                document.title = this.fileName
            } else {
                document.title = this.$t(`fe_contractors['form.heading_formResponse']`).toString()
            }

            window.print()
        },
    },
}
